import React from 'react';
import { Link } from '@amzn/awsui-components-react/polaris';
import { DefaultColumnFilter } from 'src/components/shared/TPEReactTable';

/**
 * Builds the react-table column def for a clickable table-name cell that navigates to a detail page.
 * Shared by the CLI `TablesGrid` and the segment `SegmentTablesGrid` so the Name-link behaviour lives
 * in one place. Each grid still owns its own navigation state + <TPENavigator>; this only supplies the
 * column def and calls back `navigateToDetail(tableId)` on click.
 */
export function makeNameLinkColumn(params: {
    navigateToDetail: (tableId: string) => void;
    accessor?: string;
    idAccessor?: string;
    header?: string;
}) {
    const { navigateToDetail, accessor = 'tableName', idAccessor = 'tableId', header = 'Name' } = params;
    return {
        accessor,
        Header: () => <div className="cell-text">{header}</div>,
        Filter: DefaultColumnFilter,
        Cell: (e: any) =>
            <Link className="cell-link" onFollow={() => navigateToDetail(e.row.original[idAccessor])}>{e.value}</Link>,
    };
}
